class BrushOptions {
    constructor(options) {
        this.isSpray = options.isSpray || false;
        this.sprayFlow = options.sprayFlow || 0.9;

        this.thickness = options.thickness || 1;
        this.lineRadius = options.lineRadius || 4;
        this.limitMultiplier = options.limitMultiplier || 1;
        this.friction = options.friction || 0.36;
        this.hairLength = options.hairLength || 8;
        this.gravity = options.gravity || 0;
        this.round = options.round || false;
        this.hairsOpacity = options.hairsOpacity || 0.8;
    }
}
export { BrushOptions };
